// Global Shoplift Test JS


/*==============================================================================
TEST ID: [CHS-134] [PDP] Auto-Play Product Videos [ALL]
PLATFORM: Shoplift
DATE: 2026-07

GOAL:
Automatically load and play PDP video modules when they enter the viewport.

KEY INSIGHT:
Product videos currently require a customer click before the deferred-media
content is loaded. This test removes the Watch button interaction and
automatically loads and plays the video as it enters the viewport.

BEHAVIOR:
- Only runs on PDPs containing deferred-media video modules
- Supports Desktop and Mobile video modules
- Adds .hidden to .video__controls
- Uses IntersectionObserver to preserve deferred loading behavior
- Loads video when entering viewport
- Relies on Shopify native autoplay behavior after deferred-media load
==============================================================================*/

// Initialize test
async function initTestCHS_134() {

  /* ===========================
     CONFIG
     =========================== */
  const TEST_ID = 'CHS134';
  const HYPOTHESIS_ID = '019fb49f-7ad6-7e29-ba7a-3a83f16a208f';

  var MAX_WAIT_MS = 15000;
  var POLL_INTERVAL_MS = 300;
  var OBSERVER_ROOT_MARGIN = '175px 0px';

  /* ===========================
     HELPERS
     =========================== */

  function getPdpVideoMediaItems() {
    return document.querySelectorAll(
      'deferred-media.only-mobile, deferred-media.only-desktop'
    );
  }

  function isVisibleMedia(media) {
    if (!media) return false;

    var style = window.getComputedStyle(media);

    if (style.display === 'none') return false;
    if (style.visibility === 'hidden') return false;
    if (style.opacity === '0') return false;

    var rect = media.getBoundingClientRect();

    if (rect.width === 0 && rect.height === 0) return false;

    return true;
  }

  function getVisiblePdpVideoMediaItems() {
    var mediaItems = getPdpVideoMediaItems();
    var visibleItems = [];

    for (var i = 0; i < mediaItems.length; i++) {
      if (isVisibleMedia(mediaItems[i])) {
        visibleItems.push(mediaItems[i]);
      }
    }

    return visibleItems;
  }

  function hideVideoControls(media) {
    if (!media) return;

    var controls = media.querySelector('.video__controls');

    if (controls) {
      controls.classList.add('hidden');
    }
  }

  function hideAllVideoControls(items) {
    for (var i = 0; i < items.length; i++) {
      hideVideoControls(items[i]);
    }
  }

  function loadDeferredVideo(media) {
    if (!media) return;

    hideVideoControls(media);

    if (
      typeof media.loadContent === 'function' &&
      !media.hasAttribute('data-media-loaded')
    ) {
      media.loadContent(false);
    }
  }

  function observePdpVideos(items) {
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) {
        loadDeferredVideo(items[i]);
      }

      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        loadDeferredVideo(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0,
      rootMargin: OBSERVER_ROOT_MARGIN
    });

    for (var j = 0; j < items.length; j++) {
      var media = items[j];

      if (
        media.hasAttribute(
          'data-' + TEST_ID.toLowerCase() + '-observed'
        )
      ) {
        continue;
      }

      media.setAttribute(
        'data-' + TEST_ID.toLowerCase() + '-observed',
        'true'
      );

      observer.observe(media);
    }
  }

  /* ===========================
     INIT (TARGETING + READINESS)
     =========================== */

  /* ✅ PDP targeting */
  if (!window.location.pathname.includes('/products/')) {
    console.log(`Not in ${TEST_ID} Test`);
    return;
  }

  var startTime = Date.now();

  var timer = setInterval(async function () {
    var pdpVideoMediaItems = getPdpVideoMediaItems();

    /* ✅ wait for PDP video modules */
    if (
      !pdpVideoMediaItems.length &&
      Date.now() - startTime < MAX_WAIT_MS
    ) {
      return;
    }

    clearInterval(timer);

    try {

      /* ===========================
         SHOPLIFT ASSIGNMENT
         =========================== */

      var variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

      if (variantResult) {

        // TEST - Show Variant
        (function () {

          //==========================
          // ONE-RUN GUARD
          //==========================
          if (window[TEST_ID + '_INIT']) return;
          window[TEST_ID + '_INIT'] = true;

          /* ===========================
             VIDEO QUALIFICATION
             =========================== */

          if (!pdpVideoMediaItems.length) {
            console.log(`${TEST_ID} No PDP Videos Found`);
            return;
          }

          /* ===========================
             HIDE VIDEO CONTROLS
             =========================== */

          hideAllVideoControls(pdpVideoMediaItems);

          /* ===========================
             OBSERVE VISIBLE PDP VIDEO
             =========================== */

          var visibleVideoMediaItems = getVisiblePdpVideoMediaItems();

          if (!visibleVideoMediaItems.length) {
            console.log(`${TEST_ID} No Visible PDP Videos Found`);
            return;
          }

          observePdpVideos(visibleVideoMediaItems);

          console.log(`Showing ${TEST_ID} Variant`);

        })();

      } else {

        // Show control
        // NO CHANGES DO NOTHING

        console.log(`Showing ${TEST_ID} Control`);

      }

    } catch (error) {

      // Always fail gracefully - show control experience on error

      console.error(`Shoplift test ${TEST_ID} failed:`, error);

    }

  }, POLL_INTERVAL_MS);
}

/* Guard Check - Safely Checking for Shoplift */
function whenShopliftReady(cb, timeoutMs = 5000) {
  const start = Date.now();

  const tick = setInterval(function () {
    if (window.shoplift) {
      clearInterval(tick);
      cb();
    } else if (Date.now() - start > timeoutMs) {
      clearInterval(tick);
      console.warn('Shoplift not available after ' + timeoutMs + 'ms');
    }
  }, 50);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => whenShopliftReady(initTestCHS_134));
} else {
  whenShopliftReady(initTestCHS_134);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////

/*==============================================================================
TEST ID: [CHS-130] [SEARCH] Auto Load More Button [ALL]
PLATFORM: Shoplift
DATE: 2026-07

GOAL:
When scrolling down a PLP/Collections/Search Page at the end of the results, once the Load More button enters the screen view this code will update the buttons copy to "Loading More" automatically click the CTA to load the following set of results.

KEY INSIGHT:
Target is specific by URL

BEHAVIOR:
- will update the CTA "Load More" copy to "Loading More"
- Only triggers Load More CTAs when they are on viewable on screen 
- Observes class attribute as lightweight fallback (future-safe)
==============================================================================*/

// Initialize test
async function initTestCHS_130() {
    
    // Configuration
    const TEST_ID = 'CHS130';
    const HYPOTHESIS_ID = '019ead4c-0ed5-7638-95a8-5c0a21c89daf';
    let variantResult = null;

    // Targeting - SEARCH only
    if (!window.location.pathname.startsWith('/search')) {
        return;
    }

    try {
        // Check if visitor is in the variant group
        variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

        if (variantResult) {

            // Scroll trigger (behavioral gating)
            function waitForScrollNearLoadMore(callback) {

                var triggered = false;

                function checkScroll() {

                    if (triggered) {
                        return;
                    }

                    var button = document.querySelector('.button.button--black-outline');

                    if (!button) {
                        return;
                    }

                    var rect = button.getBoundingClientRect();

                    // Trigger just before button enters view
                    if (rect.top < window.innerHeight + 150) {

                        triggered = true;
                        window.removeEventListener('scroll', checkScroll);

                        console.log(TEST_ID + ' → Scroll trigger met');

                        callback();
                    }
                }

                window.addEventListener('scroll', checkScroll);
            }

            // Delay execution until scroll condition met
            waitForScrollNearLoadMore(function() {

                // TEST - Show Variant          
                (function() {

                    // One-run guard
                    if (window[TEST_ID + '_INIT']) {
                        return;
                    }
                    window[TEST_ID + '_INIT'] = true;

                    var buttonSelector = '.button.button--black-outline';

                    // Check if element is in viewport
                    function isInViewport(el) {
                        if (!el) {
                            return false;
                        }

                        var rect = el.getBoundingClientRect();

                        if (rect.top < window.innerHeight && rect.bottom > 0) {
                            return true;
                        }

                        return false;
                    }

                    // Attempt click + update button copy
                    function tryClick(button) {
                        if (!button) {
                            return false;
                        }

                        if (button.disabled) {
                            return false;
                        }

                        if (isInViewport(button)) {

                            var label = button.querySelector('span');
                            if (label) {
                                label.textContent = 'Loading more';
                            } else {
                                button.textContent = 'Loading more';
                            }

                            button.click();
                            console.log(TEST_ID + ' → Clicked Load More:', button);

                            return true;
                        }

                        return false;
                    }

                    // Fast retry burst
                    function clickWithRetry() {
                        var attempts = 0;
                        var maxAttempts = 5;

                        var retryInterval = setInterval(function() {

                            var button = document.querySelector(buttonSelector);
                            var success = tryClick(button);

                            if (success) {
                                clearInterval(retryInterval);
                            }

                            attempts = attempts + 1;

                            if (attempts >= maxAttempts) {
                                clearInterval(retryInterval);
                            }

                        }, 120);
                    }

                    // Initial run
                    function init() {
                        clickWithRetry();
                    }

                    init();

                    // Watch for new products loading
                    var mutationObserver = new MutationObserver(function(mutations) {

                        var shouldCheck = false;

                        mutations.forEach(function(mutation) {
                            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                                shouldCheck = true;
                            }
                        });

                        if (shouldCheck) {
                            setTimeout(function() {
                                clickWithRetry();
                            }, 100);
                        }

                    });

                    mutationObserver.observe(document.body, {
                        childList: true,
                        subtree: true
                    });

                    // Fallback guard
                    setInterval(function() {
                        clickWithRetry();
                    }, 800);

                })();

                console.log('Showing ' + TEST_ID + ' Variant (On Scroll Trigger)');

            });

        } else {
            // Show control
            // NO CHANGES DO NOTHING
            console.log(`Showing ${TEST_ID} Control`);
        }

    } catch (error) {
        // Always fail gracefully - show control experience on error
        console.error(`Shoplift test ${TEST_ID} failed:`, error);
    }
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs) {

    if (!timeoutMs) {
        timeoutMs = 5000;
    }

    var start = Date.now();

    var tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        whenShopliftReady(initTestCHS_130);
    });
} else {
    whenShopliftReady(initTestCHS_130);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

